export default __webpack_public_path__ + "static/media/bv-logo.5754a535.png";